<template>
  <footer class="cm-footer">
    
    <div class="cm-footer-trust-bar">
      <div class="trust-item">
        <i class="fas fa-truck"></i>
        <span>Envíos Seguros a Todo México y USA</span>
      </div>

      <div class="trust-item">
        <i class="fas fa-lock"></i>
        <span>Pago 100% Encriptado</span>
      </div>

      <div class="trust-item">
        <i class="fas fa-ribbon"></i>
        <span>Calidad Premium Garantizada</span>
      </div>
    </div>

    <div class="cm-footer-top">

      <div class="cm-footer-brand">
        <div class="brand-container">
          <img src="@/assets/logo2.png" class="footer-logo"/>
          <h2 class="brand-title">
            San Judas
            <span>by Jesus Cavazos</span>
          </h2>
        </div>

        <p class="brand-description">
          Moda con alma de compositor. Botas, sombreros y artículos de fe
          seleccionados personalmente por Jesús Cavazos para el hombre de hoy.
        </p>
      </div>

      <div class="cm-footer-links">

        <div class="footer-col">
          <h4>Colecciones Top</h4>
          <ul>
            <li class="soon-item">
              <span class="shop-link disabled">Botas Exóticas</span>
              <span class="badge-soon">Próximamente</span>
            </li>
            <li>
              <router-link to="/categoria/sombreros-1" class="shop-link">
                Sombreros de Gala
              </router-link>
            </li>
            <li>
              <router-link to="/categoria/gorras" class="shop-link">
                Gorras Luxury
              </router-link>
            </li>
            <li>
              <router-link to="/categoria/articulos-religiosos" class="shop-link">
                Línea San Judas
              </router-link>
            </li>
          </ul>
        </div>

        <div class="footer-col">
          <h4>¿Necesitas Ayuda?</h4>
          <ul>
            <li class="tracking-note">
              <i class="fas fa-info-circle"></i>
              <p>Una vez completado el pedido, recibirás tu número de rastreo de la paquetería por correo electrónico.</p>
            </li>

            <li @click="toggleHelp" class="help-trigger">
              Contacto Directo
              <i class="fas fa-comment-dots"></i>
            </li>
          </ul>

          <div v-if="showHelp" class="contact-box">
            <p>Atención Personalizada:</p>
            <a
              href="https://wa.me/12137940033"
              target="_blank"
              class="whatsapp-btn"
            >
              <i class="fab fa-whatsapp"></i>
              WhatsApp
            </a>
          </div>
        </div>

      </div>

    </div>

    <div class="cm-footer-payments">
      <i class="fab fa-cc-visa"></i>
      <i class="fab fa-cc-mastercard"></i>
      <i class="fab fa-cc-paypal"></i>
      <i class="fab fa-cc-apple-pay"></i>
    </div>

    <div class="cm-footer-bottom">
      <span>
        © {{ year }} San Judas by Jesus Cavazos. Todos los derechos reservados.
      </span>

      <div class="cm-footer-social">
        <a href="https://www.facebook.com/jesus.cavazos.9"><i class="fab fa-facebook-f"></i></a>
        <a href="https://www.instagram.com/_cavazosj?igsh=MWw3eXJqamN6MXU2MA%3D%3D&utm_source=qr"><i class="fab fa-instagram"></i></a>
      <a href="https://www.tiktok.com/@jesuscavzs?_r=1&_t=ZS-95Cw3HMw1WJ" target="_blank">
    <i class="fab fa-tiktok"></i>
  </a>

  <a href="https://open.spotify.com/artist/1zoEdzuMeFG5QEtcpHWkU5?si=9HH5ZVbZR3yeQVNFRdPLLQ" target="_blank">
    <i class="fab fa-spotify"></i>
  </a>
        <a href="https://youtube.com/@jesuscavazs?si=T9p_AYyQ6Owfq5wD"><i class="fab fa-youtube"></i></a>
      </div>
    </div>

  </footer>
</template>


<script>
export default {
  name: "FooterSanJudasVentas",

  data() {
    return {
      showHelp: false
    };
  },

  computed: {
    year() {
      return new Date().getFullYear();
    }
  },

  methods: {
    toggleHelp() {
      this.showHelp = !this.showHelp;
    }
  }
};
</script>


<style scoped>
.cm-footer {
  background: #0f0f0f;
  color: #fff;
  font-family: 'Inter', sans-serif;
}

/* TRUST BAR - TEXTURA CUERO */
.cm-footer-trust-bar {
  background: linear-gradient(135deg, #3d231a 0%, #4b2c20 50%, #2d1a12 100%);
  position: relative;
  overflow: hidden;
  color: #e0c5a8;
  display: flex;
  justify-content: space-around;
  padding: 18px 20px;
  font-weight: 700;
  font-size: .8rem;
  text-transform: uppercase;
  flex-wrap: wrap;
  border-bottom: 2px solid #5d3a2d;
  box-shadow: inset 0 2px 10px rgba(0,0,0,0.4);
}

.cm-footer-trust-bar::before {
  content: "";
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  opacity: 0.15;
  background-image: url("https://www.transparenttextures.com/patterns/leather.png");
  pointer-events: none;
}

.trust-item {
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.6);
}

/* ACENTOS COLOR CUERO/ORO */
.brand-title span, 
.footer-col h4,
.badge-soon {
  color: #a67c52 !important;
}

/* TOP SECTION */
.cm-footer-top {
  display: grid;
  grid-template-columns: 1.4fr 2fr;
  gap: 50px;
  padding: 50px 40px;
  align-items: start;
}

/* BRAND */
.brand-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.footer-logo {
  width: 90px;
  filter: brightness(0) invert(1);
}

.brand-title {
  font-size: 1.4rem;
  font-weight: 800;
  text-transform: uppercase;
}

.brand-title span {
  display: block;
  font-size: .8rem;
  letter-spacing: 2px;
}

.brand-description {
  margin-top: 15px;
  font-size: .9rem;
  line-height: 1.6;
  opacity: .7;
  max-width: 420px;
}

/* LINKS Y COLECCIONES */
.cm-footer-links {
  display: flex;
  justify-content: space-between;
  gap: 40px;
}

.footer-col h4 {
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-col ul {
  list-style: none;
  padding: 0;
}

.footer-col li {
  margin-bottom: 12px;
}

.shop-link {
  color: #fff;
  text-decoration: none;
  opacity: .8;
  transition: .3s;
  font-size: 0.95rem;
}

.shop-link:hover:not(.disabled) {
  opacity: 1;
  color: #a67c52 !important;
  padding-left: 5px;
}

/* PROXIMAMENTE BADGE */
.soon-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.shop-link.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.badge-soon {
  font-size: 9px;
  font-weight: 700;
  border: 1px solid #a67c52;
  padding: 2px 6px;
  border-radius: 3px;
  text-transform: uppercase;
}

/* RASTREO Y AYUDA */
.tracking-note {
  background: rgba(255, 255, 255, 0.03);
  border-left: 2px solid #a67c52;
  padding: 10px 15px;
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
  max-width: 280px;
}

.tracking-note i {
  color: #a67c52;
  font-size: 0.9rem;
}

.tracking-note p {
  font-size: 0.75rem;
  line-height: 1.4;
  margin: 0;
  opacity: 0.9;
}

.help-trigger {
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
}

.contact-box {
  margin-top: 12px;
  background: rgba(255,255,255,.05);
  padding: 12px;
  border-radius: 6px;
}

.whatsapp-btn {
  display: inline-block;
  background: #25d366; /* Color original WhatsApp para resaltar */
  color: #fff !important;
  padding: 7px 14px;
  border-radius: 4px;
  margin-top: 10px;
  font-weight: 700;
  text-decoration: none;
}

/* PAYMENTS */
.cm-footer-payments {
  text-align: center;
  padding: 20px;
  font-size: 1.7rem;
  display: flex;
  justify-content: center;
  gap: 18px;
  opacity: .5;
}

/* BOTTOM */
.cm-footer-bottom {
  border-top: 1px solid rgba(255,255,255,.1);
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: .8rem;
  background: #050505;
}

.cm-footer-social a {
  color: #fff;
  font-size: 1.2rem;
  margin-left: 18px;
  transition: 0.3s;
}

.cm-footer-social a:hover {
  color: #a67c52;
}

/* MOBILE */
@media (max-width: 768px) {
  .cm-footer-top {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 40px 20px;
  }
  .brand-container {
    flex-direction: column;
  }
  .brand-description {
    margin: 15px auto;
  }
  .cm-footer-links {
    flex-direction: column;
    gap: 30px;
    align-items: center;
  }
  .tracking-note {
    margin: 0 auto 15px;
  }
  .cm-footer-bottom {
    flex-direction: column;
    gap: 15px;
  }
  .cm-footer-trust-bar {
    flex-direction: column;
    gap: 10px;
  }
}
</style>